import React, { Fragment } from 'react';
import { Text } from 'localmed-core';
import { FormattedMessage } from 'react-intl';

import { DiNotFoundPage } from '../../../../shared/components/DiLayout';

export default function SchedulingNotFoundPage() {
  return (
    <DiNotFoundPage>
      <Fragment>
        <Text>
          <FormattedMessage
            id="scheduling.SchedulingPage.PageNotFoundMessage"
            defaultMessage="Not Found."
          />
        </Text>
        <Text>
          <FormattedMessage
            id="scheduling.SchedulingPage.PageNotFoundMessage"
            defaultMessage="If this problem keeps happening, give us a call and we would be happy to help."
          />
        </Text>
      </Fragment>
    </DiNotFoundPage>
  );
}
